const bookingDetailsInvoiceAccess = ['TRAXAA_ADMIN', 'TRAXAA_ACCOUNT_USER'];
const invoiceScreenAccess = ['TRAXAA_ADMIN', 'TRAXAA_ACCOUNT_USER'];
export { bookingDetailsInvoiceAccess, invoiceScreenAccess };
